import script from "./ReviewAndSendToPlanPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewAndSendToPlanPage.vue?vue&type=script&setup=true&lang=js"

import "./ReviewAndSendToPlanPage.vue?vue&type=style&index=0&id=4b116c6f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b116c6f"]])

export default __exports__